import {
  MapGeographicPosition,
} from '/@/types/map'

export type GeojsonCoordinate = [number, number, number?]

export interface GeojsonLine {
 type: 'Feature'
 properties: {
   color: string
   directConnected?: boolean
   clampToGround?: boolean
   // Hauteur (m) ajoutée au-dessus du terrain : l'annotation suit le relief mais
   // décalée vers le haut de cette valeur (0 = posée au sol / clampToGround).
   height?: number
   // Mode d'élévation explicite et persisté (remplace l'heuristique) : 'ground' posé au
   // sol, 'agl' hauteur au-dessus du terrain, 'asl' altitude absolue MSL.
   altitudeMode?: 'ground' | 'agl' | 'asl'
 }
 geometry: {
   type: 'LineString'
   coordinates: GeojsonCoordinate[]
 }
}

export interface GeojsonPolygon {
 type: 'Feature'
 properties: {
   color: string
   clampToGround?: boolean
   height?: number
   altitudeMode?: 'ground' | 'agl' | 'asl'
   // Volume 3D : plancher/plafond + leur référence ('agl' suit le sol, 'msl' altitude fixe).
   floor?: number
   floorReference?: 'agl' | 'msl'
   ceiling?: number
   ceilingReference?: 'agl' | 'msl'
 }
 geometry: {
   type: 'Polygon'
   coordinates: GeojsonCoordinate[][]
 }
}

export interface GeojsonPoint {
 type: 'Feature'
 properties: {
   color: string
   clampToGround?: boolean
   height?: number
   altitudeMode?: 'ground' | 'agl' | 'asl'
 }
 geometry: {
   type: 'Point'
   coordinates: GeojsonCoordinate
 }
}

export interface GeojsonCircle {
 type: 'Feature'
 properties: {
   color: string
   clampToGround?: boolean
   height?: number
   altitudeMode?: 'ground' | 'agl' | 'asl'
 }
 geometry: {
   type: 'Circle'
   coordinates: GeojsonCoordinate
   radius: number
 }
}

export type GeojsonFeature = GeojsonLine | GeojsonPolygon | GeojsonPoint | GeojsonCircle

export function geographic2Coordinate (position: MapGeographicPosition): GeojsonCoordinate {
  const coordinates: GeojsonCoordinate = [position.longitude, position.latitude]
  if (position.height !== undefined) coordinates.push(position.height)
  return coordinates
}

export function generateLine (coordinates: MapGeographicPosition[], properties: GeojsonLine['properties']): GeojsonFeature {
  return {
    type: 'Feature',
    properties,
    geometry: {
      type: 'LineString',
      coordinates: coordinates.map(geographic2Coordinate),
    },
  }
}

export function generatePolygon (coordinates: MapGeographicPosition[], properties: GeojsonPolygon['properties']): GeojsonFeature {
  return {
    type: 'Feature',
    properties,
    geometry: {
      type: 'Polygon',
      coordinates: [coordinates.map(geographic2Coordinate)],
    },
  }
}

export function generatePoint (position: MapGeographicPosition, properties: GeojsonPoint['properties']): GeojsonFeature {
  return {
    type: 'Feature',
    properties,
    geometry: {
      type: 'Point',
      coordinates: geographic2Coordinate(position),
    },
  }
}

export function generateCircle (position: MapGeographicPosition, properties: GeojsonCircle['properties'], radius: number): GeojsonFeature {
  return {
    type: 'Feature',
    properties,
    geometry: {
      type: 'Circle',
      coordinates: geographic2Coordinate(position),
      radius: radius,
    },
  }
}
